
import Vue from 'vue'
import { HomeBanner } from "@/model/Home";
import Multimedia from "@/components/Multimedia.vue";

export default Vue.extend({
  name: 'HomeContest',
  components: {
    Multimedia
  },
  data: () => ({
    banner: null as HomeBanner | null
  }),
  mounted() {
    this.fetchBanner();
  },
  methods: {
    fetchBanner() {
      this.$api
        .get('/contents/home/banner')
        .then((response) => {
          this.banner = response.data;
        })
        .catch((e) => {
          console.error("Błąd ładowania bannera:", e);
        });
    },
  }
})
